import React from "react";
import PropTypes from "prop-types";
import Image from "../Components/Image";

const CartItemGroup = ({
    title,
    logo,
    children
}) => (
    <div className="cart-item-group my-4">
        {(title) && (
            <a className="cart-item-group-heading" href="">
                <Image src={`${localStorage.getItem("restUrl")}/pub/media/avatar/${logo}`}/>
                <h5 className="card-title">{title}</h5>
            </a>
        )}
        <div className="list-group cart-item-list">
            {children}
        </div>
    </div>
);

CartItemGroup.propTypes = {
    children: PropTypes.array,
    title: PropTypes.string,
    logo: PropTypes.string
};

export default CartItemGroup;
